import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import usePages, { useSelectedPage } from "../../../../Hooks/Display/usePages";
import { allowedComponentTypes } from "../../Components/utils";
import { createComponent } from "../../../../API/Display/Display";
import useComponents, { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import { ADD_COMPONENTS_TO_FLAT_LIST, TOGGLE_ADD_COMPONENT_DIALOG } from "../../../../Context/Display/Components/ComponentsContextEvents";
import { ADD_COMPONENT_TO_FLATLIST, ADD_COMPONENT_TO_PAGE } from "../../../../Context/Display/Pages/PagesContextEvents";
import { useComponentProperties } from "../../../../Hooks/Display/useComponentProperties";
import { useTranslation } from "react-i18next";

function CreateTabsDialog({ onClose }) {

    const { t } = useTranslation("display/components/tab_container", { useSuspense: false });

    const [componentType, setComponentType] = useState("");

    const [allowedComponents, setAllowedComponents] = useState([]);

    const [properties, updateGeneralProperty] = useComponentProperties();

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const entityName = usePropsStoreValue("entityName");
    const [, pageDispatch] = usePages();
    const [, dispatch] = useComponents();

    useEffect(() => {
        let allowedTypes = allowedComponentTypes[selectedPage.subPageType].filter(type => type === "View" || type === "History" || type === "Discussion" || type === "Reference");
        setAllowedComponents(allowedTypes);
        setComponentType(allowedTypes[0]);
    }, [])

    function handleComponentType(event) {
        setComponentType(event.target.value);
    }

    async function createComponents(event) {
        event.preventDefault();
        try {
            const tabComponentName = componentType === "View" ? "Detail" : componentType;
            const tabComponentLabel = componentType === "View" ? "Detail" : componentType;
            let tabName = t("new-tab-name." + tabComponentName.toLowerCase());
            let tabLabel = t("new-tab-label." + tabComponentLabel.toLowerCase());
            debugger;
            tabName = generateTabName(tabName);
            tabLabel = generateTabLabel(tabLabel);
            const createdTabResponse = await createComponent(selectedPage._id, selectedComponent.id, entityName, { componentName: tabName, componentType: "Tab", label: tabLabel });
            const response = await createComponent(selectedPage._id, createdTabResponse.id, entityName, { componentName: tabLabel, componentType: componentType, label: tabLabel });
            createdTabResponse.children = [response];
            dispatch({
                type: ADD_COMPONENTS_TO_FLAT_LIST,
                payload: createdTabResponse
            })
            dispatch({
                type: ADD_COMPONENTS_TO_FLAT_LIST,
                payload: response
            })
            dispatch({ type: TOGGLE_ADD_COMPONENT_DIALOG })
            pageDispatch({
                type: ADD_COMPONENT_TO_FLATLIST,
                payload: {
                    parentId: selectedPage.parentId,
                    pageId: selectedPage._id,
                    component: createdTabResponse
                }
            })
            pageDispatch({
                type: ADD_COMPONENT_TO_FLATLIST,
                payload: {
                    parentId: selectedPage.parentId,
                    pageId: selectedPage._id,
                    component: response
                }
            })
            dispatch({ type: TOGGLE_ADD_COMPONENT_DIALOG })
            const updatedChildren = [...properties.children, createdTabResponse]
            updateGeneralProperty("children", structuredClone(updatedChildren))
        } catch (error) {
            console.error(error);
        } finally {
            onClose();
        }
    }

    function generateTabName(tabName, count = 1) {
        const tabComponentType = componentType === "View" ? "Details" : componentType;
        let tabNameExists = properties.children.filter((child) => child.componentName === tabName);
        if (tabNameExists.length > 0) {
            tabName = "Tab - " + tabComponentType + count;
            return generateTabName(tabName, count + 1);
        }
        return tabName;
    }

    function generateTabLabel(tabLabel, count = 1) {
        const tabComponentType = componentType === "View" ? "Detail" : componentType;
        let tabLabelExists = properties.children.filter((child) => child.label === tabLabel);
        if (tabLabelExists.length > 0) {
            tabLabel = tabComponentType + count;
            return generateTabLabel(tabLabel, count + 1);
        }
        return tabLabel;
    }

    return (
        <Dialog
            width={500}
            height={200}
            title={t("createTabDialog.title")}
            onClose={onClose}
        >
            <div>
                <div className="me-1 form-label d-inline-block" required>
                    {t("createTabDialog.type")}
                </div>
                <DropDownList
                    value={componentType}
                    className="form-control-custom"
                    data={allowedComponents}
                    onChange={handleComponentType}
                />
            </div>
            <DialogActionsBar layout={"end"}>
                <div className="mb-3 me-3">
                    <button className="btn btn-secondary" onClick={onClose}>
                        {t("createTabDialog.buttons.cancelButtonText")}
                    </button>
                    <button className="btn btn-primary" onClick={createComponents}>
                        {t("createTabDialog.buttons.createButtonText")}
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}

export default CreateTabsDialog;